/**
 * Project views
 * Path: `@/views/project`
 * - Project's edm views: used for document's managment
 * - Company settings views: handle company settings
 * - Project's inspection views
 * - Project's nonconformity views
 */

import multiguard from "vue-router-multiguard"
import { requireAuth, requireCompany, requireProject } from "@/utils/middleware"
import store from "@/store" // Assure-toi d'importer ton store
import ProjectService from "@/services/ProjectService"
import CompanyService from "@/services/CompanyService"

const General = () => import("@/views/project/General.vue")
const Gant = () => import("@/views/project/Gant.vue")
const ProjectCreateUpdate = () => import("@/views/project/ProjectCreateUpdate.vue")
const ProjectFeed = () => import("@/views/project/ProjectFeed.vue")
const Projects = () => import("@/views/project/Projects.vue")
const ProjectTeam = () => import("@/views/project/ProjectTeam.vue")

// Audit
const Audits = () => import("@/views/project/audit/Audits.vue")

const Documentation = () => import("@/views/project/edm/Documentation.vue")

const AllInspections = () => import("@/views/project/inspection/AllInspections.vue")
const Inspection = () => import("@/views/project/inspection/Inspection.vue")
const InspectionCreateUpdate = () => import("@/views/project/inspection/InspectionCreateUpdate.vue")
const Inspections = () => import("@/views/project/inspection/Inspections.vue")
const Meeting = () => import("@/views/project/inspection/Meeting.vue")
const MeetingCreateUpdate = () => import("@/views/project/inspection/MeetingCreateUpdate.vue")

const AllActions = () => import("@/views/project/nonconformity/AllActions.vue")
const AllProjectActions = () => import("@/views/project/nonconformity/AllProjectActions.vue")
const AllNonConformities = () => import("@/views/project/nonconformity/AllNonConformities.vue")
const NonConformities = () => import("@/views/project/nonconformity/NonConformities.vue")
const ActionsProject = () => import("@/views/project/action/Actions.vue")
const NonConformityCreateUpdate = () =>
  import("@/views/project/nonconformity/NonConformityCreateUpdate.vue")
const ActionCreateUpdate = () => import("@/views/project/action/ActionCreateUpdate.vue")

const Cfsis = () => import("@/views/project/cfsi/Cfsis.vue")
const CfsiCreateUpdate = () => import("@/views/project/cfsi/CfsiCreateUpdate.vue")

// const PcqDsi = () => import("@/views/project/pcqDsi/PcqDsi.vue")
const PcqDsiCreateUpdate = () => import("@/views/project/pcqDsi/PcqDsiCreateUpdate.vue")
const PcqDsis = () => import("@/views/project/pcqDsi/PcqDsis.vue")
const ExternalSignature = () => import("@/views/project/pcqDsi/ExternalSignature.vue")

const PcqLiner = () => import("@/views/project/pcqLiner/pcqLiner.vue")

// DRAWERS
const ProjectDrawer = () => import("@/components/layouts/core/ProjectDrawer.vue")

const InternalNotification = () => import("@/views/project/notification/InternalNotification.vue")

export default [
  {
    path: "/inspections",
    name: "AllInspections",
    component: AllInspections,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/project/actions",
    name: "AllProjectActions",
    component: AllProjectActions,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/non-conformities",
    name: "AllNonConformities",
    component: AllNonConformities,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/non-conformities/actions",
    name: "AllActions",
    component: AllActions,
    beforeEnter: multiguard([requireAuth]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/projects/list",
    name: "Projects",
    component: Projects,
    beforeEnter: multiguard([requireAuth, requireCompany]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/audit/list",
    name: "Audits",
    component: Audits,
    beforeEnter: multiguard([requireAuth, requireCompany]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/projects/:id?/editor",
    name: "ProjectCreateUpdate",
    component: ProjectCreateUpdate,
    beforeEnter: multiguard([requireAuth, requireCompany]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/project/home",
    name: "Project",
    component: General,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/project/gant-diagram",
    name: "Gantt",
    component: Gant,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/project/feed",
    name: "ProjectFeed",
    component: ProjectFeed,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/project/documentation",
    name: "Documentation",
    component: Documentation,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/project/team",
    name: "ProjectTeam",
    component: ProjectTeam,
    beforeEnter: multiguard([requireProject]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/project/inspections",
    name: "Inspections",
    component: Inspections,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/project/inspections/:id",
    name: "Inspection",
    component: Inspection,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/project/inspections/:id/meeting/:uuid/",
    name: "InspectionMeeting",
    component: Meeting,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      // requiresAuth: false,
      layout: "default"
    }
  },
  // Inspection in unauthenticated mode
  {
    path: "/inspection/meeting/:uuid",
    component: Meeting,
    name: "InspectionMeetingUnauthenticated",
    meta: {
      layout: "white"
    }
  },
  {
    path: "/project/inspection/:id?/editor",
    name: "InspectionCreateUpdate",
    component: InspectionCreateUpdate,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default"
    }
  },
  // Form Inspection in Meeting
  {
    path: "/project/inspections/:id?",
    name: "InspectionMeetingCreateUpdate",
    component: MeetingCreateUpdate,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/project/non-conformities",
    name: "NonConformities",
    component: NonConformities,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/project/nc-actions",
    name: "Actions",
    component: ActionsProject,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/project/non-conformities/:id?/editor",
    name: "NonConformityCreateUpdate",
    component: NonConformityCreateUpdate,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/project/nc-actions/:id?/editor",
    name: "ActionCreateUpdate",
    component: ActionCreateUpdate,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/project/pcq-list",
    name: "PcqLiner",
    component: PcqLiner,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/project/pcq-dsi",
    name: "PcqDsis",
    component: PcqDsis,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/project/pcq-dsi/:id?/editor",
    name: "PcqDsiCreateUpdate",
    component: PcqDsiCreateUpdate,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/project/pcq-dsi/:id",
    component: ExternalSignature,
    name: "ExternalSignatureUnauthenticated",
    meta: {
      layout: "white"
    }
  },
  {
    path: "/project/notification",
    component: InternalNotification,
    name: "InternalNotification",
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/company/:companyId/project/:projectId/inspections/:id",
    name: "Inspections",
    component: Inspections,
    beforeEnter: multiguard([
      requireAuth,
      async (to, from, next) => {
        const { companyId, projectId, id: inspectionId } = to.params
        console.log(inspectionId)

        // Vérifie si la société est définie dans le store
        if (!store.state.app.company || store.state.app.company.id !== companyId) {
          // Récupère et stocke la société dans le store
          // Si tu as un service pour récupérer la société, tu pourrais l'utiliser ici
          const company = await CompanyService.getById(companyId)
          store.commit("app/setCompany", company)
        }

        // Vérifie si le projet est défini dans le store
        if (!store.state.app.project || store.state.app.project.id !== projectId) {
          try {
            // Appelle le service pour récupérer le projet
            const project = await ProjectService.get(this, null, projectId)

            // Stocke le projet dans le store
            store.commit("app/setProject", project)
          } catch (error) {
            console.error("Erreur lors de la récupération du projet:", error)
            return next(false) // Stoppe la navigation en cas d'erreur
          }
        }
        // Continue vers la page d'inspection
        next()
      }
    ]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/company/:companyId/project/:projectId/non-conformities/:id/editor",
    name: "NonConformityCreateUpdate",
    component: NonConformityCreateUpdate,
    beforeEnter: multiguard([
      requireAuth,
      async (to, from, next) => {
        const { companyId, projectId, id: ncId } = to.params
        console.log(ncId)

        // Vérifie si la société est définie dans le store
        if (!store.state.app.company || store.state.app.company.id !== companyId) {
          // Récupère et stocke la société dans le store
          // Si tu as un service pour récupérer la société, tu pourrais l'utiliser ici
          const company = await CompanyService.getById(companyId)
          store.commit("app/setCompany", company)
        }

        // Vérifie si le projet est défini dans le store
        if (!store.state.app.project || store.state.app.project.id !== projectId) {
          try {
            // Appelle le service pour récupérer le projet
            const project = await ProjectService.get(this, null, projectId)

            // Stocke le projet dans le store
            store.commit("app/setProject", project)
          } catch (error) {
            console.error("Erreur lors de la récupération du projet:", error)
            return next(false) // Stoppe la navigation en cas d'erreur
          }
        }
        // Continue vers la page d'inspection
        next()
      }
    ]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/company/:companyId/project/:projectId/non-conformities/:id/editor/action",
    name: "NonConformityCreateUpdate",
    component: NonConformityCreateUpdate,
    beforeEnter: multiguard([
      requireAuth,
      async (to, from, next) => {
        const { companyId, projectId, id: ncId } = to.params
        console.log(ncId)

        // Vérifie si la société est définie dans le store
        if (!store.state.app.company || store.state.app.company.id !== companyId) {
          // Récupère et stocke la société dans le store
          // Si tu as un service pour récupérer la société, tu pourrais l'utiliser ici
          const company = await CompanyService.getById(companyId)
          store.commit("app/setCompany", company)
        }

        // Vérifie si le projet est défini dans le store
        if (!store.state.app.project || store.state.app.project.id !== projectId) {
          try {
            // Appelle le service pour récupérer le projet
            const project = await ProjectService.get(this, null, projectId)

            // Stocke le projet dans le store
            store.commit("app/setProject", project)
          } catch (error) {
            console.error("Erreur lors de la récupération du projet:", error)
            return next(false) // Stoppe la navigation en cas d'erreur
          }
        }
        // Continue vers la page d'inspection
        next({
          name: "NonConformityCreateUpdate",
          params: {
            ...to.params,
            tab: 4
          }
        })
      }
    ]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/company/:companyId/project/:projectId/home",
    name: "Project",
    component: General,
    beforeEnter: multiguard([
      requireAuth,
      async (to, from, next) => {
        const { companyId, projectId, id: ncId } = to.params
        console.log(ncId)

        // Vérifie si la société est définie dans le store
        if (!store.state.app.company || store.state.app.company.id !== companyId) {
          // Récupère et stocke la société dans le store
          // Si tu as un service pour récupérer la société, tu pourrais l'utiliser ici
          const company = await CompanyService.getById(companyId)
          store.commit("app/setCompany", company)
        }

        // Vérifie si le projet est défini dans le store
        if (!store.state.app.project || store.state.app.project.id !== projectId) {
          try {
            // Appelle le service pour récupérer le projet
            const project = await ProjectService.get(this, null, projectId)

            // Stocke le projet dans le store
            store.commit("app/setProject", project)
          } catch (error) {
            console.error("Erreur lors de la récupération du projet:", error)
            return next(false) // Stoppe la navigation en cas d'erreur
          }
        }
        // Continue vers la page d'inspection
        next()
      }
    ]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/project/cfsis",
    name: "Cfsis",
    component: Cfsis,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default",
      drawer: ProjectDrawer
    }
  },
  {
    path: "/project/cfsis/:id?/editor",
    name: "CfsiCreateUpdate",
    component: CfsiCreateUpdate,
    beforeEnter: multiguard([requireAuth, requireProject]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/company/:companyId/project/:projectId/cfsis/:id/editor",
    name: "CfsiCreateUpdate",
    component: CfsiCreateUpdate,
    beforeEnter: multiguard([
      requireAuth,
      async (to, from, next) => {
        const { companyId, projectId, id: ncId } = to.params
        console.log(ncId)

        // Vérifie si la société est définie dans le store
        if (!store.state.app.company || store.state.app.company.id !== companyId) {
          // Récupère et stocke la société dans le store
          // Si tu as un service pour récupérer la société, tu pourrais l'utiliser ici
          const company = await CompanyService.getById(companyId)
          store.commit("app/setCompany", company)
        }

        // Vérifie si le projet est défini dans le store
        if (!store.state.app.project || store.state.app.project.id !== projectId) {
          try {
            // Appelle le service pour récupérer le projet
            const project = await ProjectService.get(this, null, projectId)

            // Stocke le projet dans le store
            store.commit("app/setProject", project)
          } catch (error) {
            console.error("Erreur lors de la récupération du projet:", error)
            return next(false) // Stoppe la navigation en cas d'erreur
          }
        }
        // Continue vers la page d'inspection
        next()
      }
    ]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/company/:companyId/project/:projectId/cfsis/:id/editor/action",
    name: "CfsiCreateUpdate",
    component: CfsiCreateUpdate,
    beforeEnter: multiguard([
      requireAuth,
      async (to, from, next) => {
        const { companyId, projectId, id: ncId } = to.params
        console.log(ncId)

        // Vérifie si la société est définie dans le store
        if (!store.state.app.company || store.state.app.company.id !== companyId) {
          // Récupère et stocke la société dans le store
          // Si tu as un service pour récupérer la société, tu pourrais l'utiliser ici
          const company = await CompanyService.getById(companyId)
          store.commit("app/setCompany", company)
        }

        // Vérifie si le projet est défini dans le store
        if (!store.state.app.project || store.state.app.project.id !== projectId) {
          try {
            // Appelle le service pour récupérer le projet
            const project = await ProjectService.get(this, null, projectId)

            // Stocke le projet dans le store
            store.commit("app/setProject", project)
          } catch (error) {
            console.error("Erreur lors de la récupération du projet:", error)
            return next(false) // Stoppe la navigation en cas d'erreur
          }
        }
        // Continue vers la page d'inspection
        next({
          name: "CfsiCreateUpdate",
          params: {
            ...to.params,
            tab: 3
          }
        })
      }
    ]),
    meta: {
      layout: "default"
    }
  }
]
